<template>
  <div class="service-section">
    <div class="breadcrumb">
      <img :src="pointImg" alt="" class="breadcrumb-icon">
      <span>当前位置：
        <span class="breadcrumb-link" @click="$emit('go-home')">首页</span>
        <span> / </span>
        <span>服务咨询</span>
      </span>
    </div>
    <div class="service-layout">
      <div class="chat-container">
        <div class="chat-body" ref="chatBody">
          <div v-for="(msg, index) in messages" :key="index"
            class="msg-row" :class="{ 'msg-ai': msg.type === 'ai', 'msg-user': msg.type === 'user' }">
            <div v-if="msg.type === 'ai'" class="avatar ai-avatar">小圣</div>
            <div class="msg-bubble" :class="msg.type">
              <div v-if="msg.type === 'ai'" v-html="msg.text" :class="{ 'welcome-text': msg.welcome }"></div>
              <div v-else :class="{ 'welcome-text': msg.welcome }">{{ msg.text }}</div>
              <div v-if="msg.type === 'ai' && msg.options" class="msg-options">
                <div v-for="(opt, oi) in msg.options" :key="oi"
                  class="option-item" @click="sendQuick(opt)">{{ opt }}</div>
              </div>
            </div>
            <div v-if="msg.type === 'user'" class="avatar user-avatar">我</div>
          </div>
          <div v-if="typing" class="msg-row msg-ai">
            <div class="avatar ai-avatar">小圣</div>
            <div class="msg-bubble ai">
              <div class="typing-dots">
                <span></span><span></span><span></span>
              </div>
            </div>
          </div>
        </div>
        <div class="quick-bar">
          <span v-for="(q, i) in quickTips" :key="i"
            class="quick-chip" @click="sendQuick(q)">{{ q }}</span>
        </div>
        <div class="chat-input">
          <textarea v-model="inputText" placeholder="请输入您的问题...Enter发送" @keydown.enter.exact.prevent="sendMsg"></textarea>
          <button class="send-btn" @click="sendMsg">发送</button>
        </div>
      </div>
      <div class="sun-panel">
        <div class="speech-bubble">欢迎您来到花果山景区，俺是小圣！时刻在您身边提供旅游服务咨询，伴您尽享西游故里之美。</div>
        <div class="sun-img-wrap">
          <img :src="sunImg" alt="" class="sun-img">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getFaq } from '../api/index'
import pointImg from '../assets/imgs/point.png'
import sunImg from '../assets/imgs/7月14日(2).gif'
import voiceOnImg from '../assets/imgs/图层 63@2x.png'
import voiceOffImg from '../assets/imgs/图层 62@2x.png'

export default {
  name: 'ServiceSection',
  emits: ['go-home'],
  data() {
    return {
      pointImg,
      sunImg,
      voiceOnImg,
      voiceOffImg,
      voiceOn: true,
      inputText: '',
      typing: false,
      messages: [{
        type: 'ai',
        text: '您好，我是小圣，有什么我能帮您的吗？',
        welcome: true,
        time: this.now(),
        options: ['花果山门票如何购买？', '花果山大巴车去哪里坐？'],
      }],
      quickTips: ['景区电话', '如何购票', '景区门票', '门票优惠', '水帘洞预约', '景区导览图', '营业时间'],
    }
  },
  methods: {
    async sendMsg() {
      const text = this.inputText.trim()
      if (!text) return
      this.messages.push({ type: 'user', text, time: this.now() })
      this.inputText = ''
      this.typing = true
      this.$nextTick(() => this.scrollBottom())
      try {
        const res = await getFaq(text)
        this.typing = false
        if (res.code === 200 && res.data) {
          const answer = res.data.answer || '抱歉，我暂时无法回答您的问题，请拨打咨询电话了解更多信息。'
          this.messages.push({ type: 'ai', text: answer, time: this.now() })
        }
      } catch (e) {
        this.typing = false
        this.messages.push({ type: 'ai', text: '抱歉，我暂时无法回答您的问题，请拨打咨询电话了解更多信息。', time: this.now() })
      }
      this.$nextTick(() => this.scrollBottom())
    },
    sendQuick(text) {
      this.inputText = text
      this.sendMsg()
    },
    now() {
      const d = new Date()
      return `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`
    },
    scrollBottom() {
      const el = this.$refs.chatBody
      if (el) el.scrollTop = el.scrollHeight
    },
  },
}
</script>

<style scoped lang="less">
.service-section{
  .breadcrumb{
    padding-top: 0.2rem;
    padding-left: 0.1rem;
    padding-bottom: 0.2rem;
    font-size: 0.24rem;
    color: #666;
    display: flex;
    align-items: center;
    .breadcrumb-icon{
      width: 0.2rem;
      margin-right: 0.1rem;
    }
    .breadcrumb-link{
      cursor: pointer;
      &:hover{ color: #369BF8; }
    }
  }
  .service-layout{
    display: flex;
    height: 10rem;
    margin: 0.3rem;
    border: 1px solid #e0e0e0;
    border-radius: 0.1rem;
      .chat-container{
        flex: 1;
        min-width: 0;
        background: #F5F5F5;
      overflow: hidden;
      display: flex;
      flex-direction: column;
        .chat-body{
          flex: 1;
          overflow-y: auto;
        padding: 0.3rem;
        background: #F5F7FA;
        .msg-row{
          display: flex;
          margin-bottom: 0.25rem;
          .avatar{
            width: 0.5rem;
            height: 0.5rem;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 0.16rem;
            color: #fff;
            flex-shrink: 0;
            &.ai-avatar{ background: #369BF8; }
            &.user-avatar{ background: #0E8064; }
          }
          &.msg-ai{
            .msg-bubble.ai{
              background: #fff;
              border-radius: 0 0.15rem 0.15rem 0.15rem;
              margin-left: 0.15rem;
              color: #0C0C0C;
              font-size: 0.2rem;
              line-height: 1.6;
              max-width: 65%;
              padding: 0.18rem 0.25rem;
              position: relative;
              .welcome-text{
                font-size: 0.25rem;
              }
              .msg-options{
                display: flex;
                flex-wrap: wrap;
                gap: 0.1rem;
                margin-top: 0.2rem;
                .option-item{
                  background: #E3F0FF;
                  color: #369BF8;
                  padding: 0.08rem 0.18rem;
                  border-radius: 0.05rem;
                  cursor: pointer;
                  font-size: 0.16rem;
                  &:hover{ background: #369BF8; color: #fff; }
                }
              }
            }
            .typing-dots{
              display: flex;
              gap: 0.06rem;
              padding: 0.05rem 0;
              span{
                width: 0.1rem;
                height: 0.1rem;
                border-radius: 50%;
                background: #bbb;
                animation: typing 1.4s infinite;
                &:nth-child(2){ animation-delay: 0.2s; }
                &:nth-child(3){ animation-delay: 0.4s; }
              }
            }
          }
          &.msg-user{
            justify-content: flex-end;
            .msg-bubble.user{
              background: #369BF8;
              border-radius: 0.15rem 0 0.15rem 0.15rem;
              margin-right: 0.15rem;
              color: #fff;
              line-height: 1.5;
              max-width: 65%;
              padding: 0.18rem 0.25rem;
              font-size: 0.18rem;
            }
          }
        }
      }
      .quick-bar{
        display: flex;
        flex-wrap: wrap;
        gap: 0.1rem;
        padding: 0.15rem 0.2rem;
        background: #fff;
        border-top: 1px solid #eee;
        .quick-chip{
          font-size: 0.16rem;
          color: #369BF8;
          background: #E3F0FF;
          padding: 0.08rem 0.18rem;
          border-radius: 0.3rem;
          cursor: pointer;
          &:hover{ background: #369BF8; color: #fff; }
        }
      }
      .chat-input{
        height: 1.5rem;
        border-top: 1px solid #e0e0e0;
        padding: 0 0.2rem;
        flex-shrink: 0;
        background: #fff;
        position: relative;
        textarea{
          width: 100%;
          height: 1.1rem;
          margin-top: 0.2rem;
          border: 1px solid #e0e0e0;
          border-radius: 0.08rem;
          padding: 0.12rem 0.8rem 0.12rem 0.15rem;
          font-size: 0.18rem;
          outline: none;
          resize: none;
          font-family: inherit;
          box-sizing: border-box;
          &:focus{ border-color: #369BF8; }
        }
        .send-btn{
          position: absolute;
          right: 0.3rem;
          bottom: 0.3rem;
          width: 0.7rem;
          height: 0.4rem;
          background: #369BF8;
          color: #fff;
          border: none;
          border-radius: 0.2rem;
          font-size: 0.17rem;
          cursor: pointer;
          &:hover{ background: #1372C9; }
        }
      }
    }
      .sun-panel{
        width: 3.4rem;
        flex-shrink: 0;
        display: flex;
        flex-direction: column;
        padding-top: 1.4rem;
        align-items: center;
        background: #F0F2F5;
        padding-top: 1.6rem;
        .speech-bubble{
          width: 2.47rem;
          background: linear-gradient(135deg, #816BFE, #476BFF);
          border: none;
          border-radius: 0.15rem;
          padding: 0.1rem;
          font-size: 0.15rem;
          color: #fff;
          line-height: 1.5;
          text-align: left;
          position: relative;
          margin-bottom: -0.3rem;
          &::after{
            content: '';
            position: absolute;
            bottom: -0.15rem;
            left: 50%;
            transform: translateX(-50%);
            width: 0;
            height: 0;
            border-left: 0.1rem solid transparent;
            border-right: 0.1rem solid transparent;
            border-top: 0.16rem solid #476BFF;
        }
      }
      .sun-img-wrap{
        position: relative;
        .sun-img{
          width: 2.39rem;
          height: auto;
          display: block;
        }
        .voice-icons{
          position: absolute;
          bottom: -0.05rem;
          right: 0.35rem;
            .voice-icon{
              width: 0.32rem;
            cursor: pointer;
          }
        }
      }
    }
  }
}

@keyframes typing{
  0%, 60%, 100%{ opacity: 0.3; transform: scale(0.8); }
  30%{ opacity: 1; transform: scale(1); }
}
</style>
